export class AdsUser {
    id!: number;
    first_name!: string;
    last_name!: string;
    email!: string;
    mobile_phone!: string;
    type!: string;
    created_at!: Date;
    updated_at!: Date;
    created_by!: AdsUser;
    updated_by!: AdsUser;
}
